<template>
  <div>
    <h2
      v-if="blok.title"
      class="title"
      :class="`${titleClass} ${textColorClass(blok.titleVariant, blok.bgVariant, 'text-darker')}`"
    >
      {{ blok.title }}
    </h2>
    <h3
      v-if="blok.subtitle"
      class="subtitle"
      :class="`${blok.title ? 'mt-4 lg:mt-10' : ''} ${subtitleClass} ${textColorClass(blok.subtitleVariant, blok.bgVariant, 'text-darker')}`"
    >
      {{ blok.subtitle }}
    </h3>
    <RichText
      :blok="blok"
      :class="[{ 'mt-6 lg:mt-8': blok.title || blok.subtitle }, richTextClass]"
      :rich-text-content="richTextContent"
    />
  </div>
</template>

<script setup>
import { useColorPalette } from '../composables/colorPalette'
import RichText from './RichText.vue'

defineProps({
  blok: {
    type: Object,
    required: true,
  },
  titleClass: {
    type: String,
    default: '',
  },
  subtitleClass: {
    type: String,
    default: '',
  },
  richTextClass: {
    type: String,
    default: '',
  },
  richTextContent: {
    type: [Object, Boolean],
    default: false,
  },
})

const { textColorClass } = useColorPalette()
</script>
